import { render, staticRenderFns } from "./UserEditNameModal.vue?vue&type=template&id=1dd93877&scoped=true&"
import script from "./UserEditNameModal.vue?vue&type=script&lang=js&"
export * from "./UserEditNameModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd93877",
  null
  
)

export default component.exports